exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-side-panel{display:block}adp-side-panel .side-panel-wrap{width:100%;padding-top:20px;border-radius:4px;background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.05),0 0 4px 0 rgba(0,0,0,.05)}adp-side-panel .panel-header{padding:0 20px}adp-side-panel .panel-header h3{display:inline-block;vertical-align:top;margin-bottom:0;color:#0e5061}adp-side-panel .panel-header h4{margin-bottom:0}adp-side-panel .panel-header h5{font-family:ProximaNova-Semibold,Arial,Helvetica,sans-serif}adp-side-panel .panel-header .ico,adp-side-panel .panel-header .icon,adp-side-panel .panel-header .material-icons{cursor:pointer}adp-side-panel .panel-header .hyperlink{font-size:26px;-webkit-transform:rotate(45deg);transform:rotate(45deg);margin-top:2px;margin-right:10px}adp-side-panel .panel-section{padding:15px 20px;border-top:1px solid #e4e4e4}adp-side-panel .panel-section:last-of-type{padding-bottom:0}adp-side-panel .panel-section.section-wrap{padding:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpSidePanel/adpSidePanel.less
// module id = 456
// module chunks = 0